import * as React from "react";
import { Link } from "react-router-dom";
import MailboxSidebar from "./MailboxSidebar";
import MailboxStore from "../../../../stores/MailboxStore";
import actionTypes from "../../../../actions/ActionTypes";
import {
  CreateMailbox,
  GetMailboxList,
  UpdateMailbox,
  LoadMailbox,
  TestMailbox,
  AuthenticateOAuth,
  InstructionCheck,
  DeleteMailbox,
  UpdateMailboxPassword,
  TestMailboxSend
} from "../../../../actions/MailboxActions";
import CredentialStore from "../../../../stores/CredentialStore";
import {
  GetCredentialList
} from "../../../../actions/CredentialActions";
import MailboxSendTest from "./MailboxSendTest";
class MailboxView extends React.Component {
  constructor(props) {
    super(props);
    this.interval = void 0;
    this.state = {
      currentMailbox: {
        name: "",
        server: "",
        serverType: 0,
        port: 0,
        authenticationMethod: 0,
        username: "",
        domain: "",
        maxMessageSizeMb: 10,
        emailAddress: "",
        newMbId: 0,
        cilentId: "",
        useSystemClientId: false,
        passWord: "",
        credentialId: null
      },
      isDirty: false,
      error: "",
      isTesting: false,
      isTestingSend: false,
      isSaving: false,
      changingPassword: false,
      newPass1: "",
      newPass2: "",
      passwordErrors: [
        { key: 1, error: "Password and confirm password do not match" },
        { key: 2, error: "Password must be at least 6 characters long" }
      ],
      showPasswordError: false,
      testResult: void 0,
      isAuthenticating: false,
      oauthInstr: void 0,
      authResult: void 0,
      credentials: [],
      currentAuthMethodCredentials: [],
      showTestSend: false
    };
    this.updateMailbox = this.updateMailbox.bind(this);
    this.editMailboxName = this.editMailboxName.bind(this);
    this.editServerSettings = this.editServerSettings.bind(this);
    this.toggleChangePassword = this.toggleChangePassword.bind(this);
    this.UpdateChangePassword2 = this.UpdateChangePassword2.bind(this);
    this.editNewPass = this.editNewPass.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.toggleUseSystemClientId = this.toggleUseSystemClientId.bind(this);
    this.editClientId = this.editClientId.bind(this);
    this.startMailboxTest = this.startMailboxTest.bind(this);
    this.closeTestResult = this.closeTestResult.bind(this);
    this.startAuthentication = this.startAuthentication.bind(this);
    this.checkInstructions = this.checkInstructions.bind(this);
    this.closeInstructions = this.closeInstructions.bind(this);
    this.deleteMailbox = this.deleteMailbox.bind(this);
    this.onCredentialStoreUpdate = this.onCredentialStoreUpdate.bind(this);
    this.editCredential = this.editCredential.bind(this);
    this.editCurrentAuthMethodCredentials = this.editCurrentAuthMethodCredentials.bind(this);
    this.sendTestMail = this.sendTestMail.bind(this);
    this.closeTestSend = this.closeTestSend.bind(this);
  }
  componentDidMount() {
    MailboxStore.addChangeListener(this.onStoreUpdate);
    CredentialStore.addChangeListener(this.onCredentialStoreUpdate);
    this.updateMailbox();
    GetCredentialList();
  }
  componentWillUnmount() {
    MailboxStore.removeChangeListener(this.onStoreUpdate);
    CredentialStore.removeChangeListener(this.onCredentialStoreUpdate);
  }
  componentDidUpdate() {
    this.updateMailbox();
  }
  updateMailbox() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let mailboxId = parseInt(pathParts[pathParts.length - 1], 10);
    if (mailboxId !== 0 && (this.state.currentMailbox === void 0 || this.state.currentMailbox.mailboxId !== mailboxId)) {
      LoadMailbox(mailboxId);
    } else if (mailboxId === 0 && this.state.currentMailbox !== void 0 && this.state.currentMailbox.mailboxId !== 0) {
      let currentMailbox = {};
      currentMailbox.mailboxId = 0;
      currentMailbox.name = "";
      currentMailbox.server = "";
      currentMailbox.mailboxType = 0;
      currentMailbox.port = 0;
      currentMailbox.authenticationMethod = 0;
      currentMailbox.username = "";
      currentMailbox.domain = "";
      currentMailbox.maxMessageSizeMb = 10;
      currentMailbox.emailAddress = "";
      this.setState({
        currentMailbox
      });
    }
  }
  onStoreUpdate() {
    let lastAction = MailboxStore.lastChange();
    if (lastAction === "MailboxLoadOne") {
      let mb = MailboxStore.getCurrentMailbox();
      this.setState({ currentMailbox: mb, isSaving: false, isDirty: false });
      let stringType = "";
      if (mb.authenticationMethod === 1) {
        stringType = "Username & Password";
      } else if (mb.authenticationMethod === 2) {
        stringType = "";
      } else if (mb.authenticationMethod === 3 || mb.authenticationMethod === 4) {
        stringType = "Microsoft OAuth";
      }
      let currentAuthMethodCredentials = this.state.credentials.filter((x) => x.type === stringType);
      this.setState({ currentAuthMethodCredentials });
    }
    if (lastAction === actionTypes.MailboxUpdateOne) {
      let mb = MailboxStore.getCurrentMailbox();
      this.setState({ currentMailbox: mb, isSaving: false, isDirty: false });
      GetMailboxList();
      if (this.state.isTesting) {
        console.log(this.state.currentMailbox);
        TestMailbox(this.state.currentMailbox);
      }
      if (this.state.isTestingSend) {
        TestMailboxSend(this.state.currentMailbox);
      }
      if (this.state.isAuthenticating) {
        AuthenticateOAuth(this.state.currentMailbox.mailboxId);
        this.interval = setInterval(this.checkInstructions, 1e3);
      }
    }
    if (lastAction === actionTypes.MailboxCreateOne) {
      let mb = MailboxStore.getCurrentMailbox();
      this.setState({ newMbId: mb.mailboxId }, () => {
        let link = document.getElementById("newMbLink");
        link.click();
      });
      this.setState({ currentMailbox: mb, isSaving: false, isDirty: false });
      GetMailboxList();
      if (this.state.isAuthenticating) {
        AuthenticateOAuth(this.state.currentMailbox.mailboxId);
        this.interval = setInterval(this.checkInstructions, 1e3);
      }
    }
    if (lastAction === actionTypes.MailboxTest) {
      let result = MailboxStore.getTestResult();
      if (result.message.includes("Authentication unsuccessful")) {
        result.message = "Authentication unsuccessful. " + result.message;
      }
      this.setState({ isTesting: false, testResult: result });
    }
    if (lastAction === actionTypes.MailboxDelete) {
      let x = MailboxStore.getLastError();
      if (x === "") {
        let link = document.getElementById("mailboxHome");
        link.click();
      } else {
      }
    }
    if (lastAction === actionTypes.MailboxInstructions) {
      let instr = MailboxStore.getInstructions();
      this.setState({ oauthInstr: instr });
      clearInterval(this.interval);
    }
    if (lastAction === actionTypes.MailboxAuthenticate) {
      let result = MailboxStore.getAuthResult();
      this.setState({ oauthInstr: void 0, authResult: result });
    }
  }
  onCredentialStoreUpdate() {
    let lastAction = CredentialStore.lastChange();
    if (lastAction === actionTypes.CredentialList) {
      let credentials = CredentialStore.getCredentials();
      console.log(credentials);
      this.setState({ credentials }, () => {
        let mb = this.state.currentMailbox;
        let stringType = "";
        if (mb.authenticationMethod === 1) {
          stringType = "Username & Password";
        } else if (mb.authenticationMethod === 2) {
          stringType = "";
        } else if (mb.authenticationMethod === 3 || mb.authenticationMethod === 4) {
          stringType = "Microsoft OAuth";
        }
        let currentAuthMethodCredentials = this.state.credentials.filter((x) => x.type === stringType);
        let cb = this.state.currentMailbox;
        this.setState({ currentAuthMethodCredentials, currentMailbox: cb });
      });
    }
    console.log("looking out");
    console.log(this.state.credentials);
  }
  editMailboxName(e) {
    let mb = this.state.currentMailbox;
    mb.name = e.target.value;
    this.setState({ currentMailbox: mb, isDirty: true });
  }
  editServerSettings(e, setting) {
    let currentAuthMethodCredentials = this.state.currentAuthMethodCredentials;
    let mb = this.state.currentMailbox;
    switch (setting) {
      case "server":
        mb.server = e.target.value;
        break;
      case "serverType":
        mb.mailboxType = parseInt(e.target.value, 10);
        break;
      case "port":
        if (e.target.value === "") {
          mb.port = 0;
        } else {
          mb.port = parseInt(e.target.value, 10);
        }
        break;
      case "authMethod":
        mb.authenticationMethod = parseInt(e.target.value, 10);
        let stringType = "Username & Password";
        if (mb.authenticationMethod === 1) {
          stringType = "Username & Password";
        } else if (mb.authenticationMethod === 2) {
          stringType = "";
        } else if (mb.authenticationMethod === 3 || mb.authenticationMethod === 4) {
          stringType = "Microsoft OAuth";
        }
        currentAuthMethodCredentials = this.state.credentials.filter((x) => x.type === stringType);
        console.log("CURRENT AUTH MEHTOD CREDS");
        console.log(currentAuthMethodCredentials);
        break;
      default:
        break;
    }
    this.setState({ currentMailbox: mb, isDirty: true, currentAuthMethodCredentials });
  }
  editEmailSettings(e, setting) {
    let mb = this.state.currentMailbox;
    switch (setting) {
      case "emailAddress":
        mb.emailAddress = e.target.value;
        break;
      case "maxMessageSizeMb":
        if (e.target.value === "") {
          mb.maxMessageSizeMb = 0;
        } else {
          mb.maxMessageSizeMb = parseInt(e.target.value, 10);
        }
        break;
      case "domain":
        mb.domain = e.target.value;
        break;
      case "username":
        mb.username = e.target.value;
        break;
      default:
        break;
    }
    this.setState({ currentMailbox: mb, isDirty: true });
  }
  toggleChangePassword() {
    let chPass = this.state.changingPassword;
    this.setState({ changingPassword: !chPass });
  }
  UpdateChangePassword2() {
    let mb = this.state.currentMailbox;
    mb.passWord = this.state.newPass1;
    this.setState({ currentMailbox: mb });
    UpdateMailboxPassword(this.state.currentMailbox, this.state.newPass1);
    let chPass = this.state.changingPassword;
    this.setState({ changingPassword: !chPass });
  }
  editNewPass(e, passwordtype) {
    let pass1 = this.state.newPass1;
    let pass2 = this.state.newPass2;
    switch (passwordtype) {
      case "newPass1":
        this.setState({ newPass1: e.target.value });
        pass1 = e.target.value;
        break;
      case "newPass2":
        this.setState({ newPass2: e.target.value });
        pass2 = e.target.value;
        break;
      default:
        break;
    }
    if (pass1 === "" && pass2 === "") {
      this.setState({ showPasswordError: false });
    } else {
      let errors = [];
      if (pass1.length < 6 || pass2.length < 6) {
        errors.push({
          key: 1,
          error: "Password must be at least 6 characters long"
        });
      }
      if (pass1 !== pass2) {
        errors.push({
          key: 2,
          error: "Password and confirm password do not match"
        });
      }
      if (errors.length > 0) {
        this.setState({ showPasswordErrors: true, passwordErrors: errors });
      } else {
        this.setState({ showPasswordErrors: false, passwordErrors: [] });
      }
    }
  }
  onSave() {
    if (this.state.currentMailbox.mailboxId === 0) {
      CreateMailbox(this.state.currentMailbox);
      this.setState({ isSaving: true });
    } else {
      UpdateMailbox(this.state.currentMailbox);
      this.setState({ isSaving: true });
    }
  }
  toggleUseSystemClientId(e) {
    let mb = this.state.currentMailbox;
    mb.useSystemClientId = e.target.checked;
    this.setState({ currentMailbox: mb });
  }
  editClientId(e) {
    let mb = this.state.currentMailbox;
    mb.clientId = e.target.value;
    this.setState({ currentMailbox: mb });
    this.setState({ isDirty: true });
  }
  startMailboxTest() {
    this.setState({ isTesting: true });
    if (this.state.currentMailbox.mailboxId === 0) {
      CreateMailbox(this.state.currentMailbox);
      this.setState({ isSaving: true });
    } else {
      UpdateMailbox(this.state.currentMailbox);
      this.setState({ isSaving: true });
    }
  }
  deleteMailbox() {
    let mb = this.state.currentMailbox;
    this.setState({ currentMailbox: mb });
    DeleteMailbox(this.state.currentMailbox.mailboxId);
  }
  closeTestResult() {
    this.setState({ isTesing: false, testResult: void 0 });
  }
  startAuthentication() {
    this.setState({ isAuthenticating: true });
    if (this.state.currentMailbox.mailboxId === 0) {
      CreateMailbox(this.state.currentMailbox);
    } else {
      UpdateMailbox(this.state.currentMailbox);
    }
  }
  checkInstructions() {
    console.log(this.state.currentMailbox);
    InstructionCheck(this.state.currentMailbox.mailboxId);
  }
  closeInstructions() {
    this.setState({
      oauthInstr: void 0,
      authResult: void 0,
      isAuthenticating: false
    });
  }
  editCredential(e) {
    let mb = this.state.currentMailbox;
    mb.credentialId = e.target.value;
    this.setState({ currentMailbox: mb });
    this.setState({ isDirty: true });
  }
  editCurrentAuthMethodCredentials(e) {
    let mb = this.state.currentMailbox;
    mb.clientId = e.target.value;
    this.setState({ currentMailbox: mb });
    this.setState({ isDirty: true });
  }
  sendTestMail() {
    this.setState({ showTestSend: true });
  }
  closeTestSend() {
    console.log("close");
    this.setState({ showTestSend: false });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(MailboxSidebar, null), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "mailboxHome",
        className: "nav-link",
        to: `/Admin/Mailbox`,
        style: { display: "none" }
      }
    ), this.state.currentMailbox !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill p-4",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Mailbox Name")),
        /* @__PURE__ */ React.createElement("div", { className: "card-body row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            value: this.state.currentMailbox.name,
            onChange: this.editMailboxName
          }
        )))
      ),
      this.state.isDirty && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success mt-2",
          onClick: this.onSave
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-save" }),
        " Save"
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card mt-2" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Server settings")), /* @__PURE__ */ React.createElement("div", { className: "card-body row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Server:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          value: this.state.currentMailbox.server,
          onChange: (e) => this.editServerSettings(e, "server")
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Server Type:"), /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select",
          value: this.state.currentMailbox.mailboxType,
          onChange: (e) => this.editServerSettings(e, "serverType")
        },
        /* @__PURE__ */ React.createElement("option", { value: "0" }),
        /* @__PURE__ */ React.createElement("option", { value: "11" }, "InboundAutomation (IMAP)"),
        /* @__PURE__ */ React.createElement("option", { value: "12" }, "Notification (SMTP)")
      )), /* @__PURE__ */ React.createElement("div", { className: "col-6 mt-3" }, /* @__PURE__ */ React.createElement("label", null, "Port:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          value: this.state.currentMailbox.port,
          onChange: (e) => this.editServerSettings(e, "port")
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col-6 mt-3" }, /* @__PURE__ */ React.createElement("label", null, "Authentication Method:"), /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select",
          value: this.state.currentMailbox.authenticationMethod,
          onChange: (e) => this.editServerSettings(e, "authMethod")
        },
        /* @__PURE__ */ React.createElement("option", { value: "0" }, "Email Address and Password"),
        /* @__PURE__ */ React.createElement("option", { value: "1" }, "Domain\\User Name and Password"),
        /* @__PURE__ */ React.createElement("option", { value: "3" }, "MS OAuth (Device Credentials)"),
        /* @__PURE__ */ React.createElement("option", { value: "4" }, "MS OAuth (Client Credentials)"),
        /* @__PURE__ */ React.createElement("option", { value: "2" }, "No Authentication")
      )), /* @__PURE__ */ React.createElement("div", { className: "col-12" }, this.state.currentMailbox.mailboxId !== 0 && !this.state.isTesting && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success mt-3",
          onClick: this.startMailboxTest
        },
        "Test Mailbox Connection"
      ), this.state.currentMailbox.mailboxId !== 0 && this.state.isTesting && /* @__PURE__ */ React.createElement("button", { className: "btn btn-success mt-3" }, /* @__PURE__ */ React.createElement(
        "i",
        {
          className: "fa-solid fa-spinner fa-spin"
        }
      )), this.state.currentMailbox.mailboxType === 12 && this.state.currentMailbox.mailboxId !== 0 && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-primary mt-3 ms-2",
          onClick: this.sendTestMail
        },
        this.state.isTestingSend === true && /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-solid fa-spinner fa-spin"
          }
        ),
        this.state.isTestingSend === false && /* @__PURE__ */ React.createElement("span", null, "Send Test Message")
      ), this.state.currentMailbox.mailboxId !== 0 && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "float-end btn btn-danger mt-3 ms-4",
          onClick: this.deleteMailbox
        },
        "Delete Mailbox"
      )))),
      /* @__PURE__ */ React.createElement("div", { className: "card mt-2" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Email settings")), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Email Address:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          value: this.state.currentMailbox.emailAddress,
          onChange: (e) => this.editEmailSettings(e, "emailAddress")
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Max Email Size (Mb):"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          value: this.state.currentMailbox.maxMessageSizeMb,
          onChange: (e) => this.editEmailSettings(e, "maxMessageSizeMb")
        }
      ))), (this.state.currentMailbox.authenticationMethod === 0 || this.state.currentMailbox.authenticationMethod === 1) && /* @__PURE__ */ React.createElement(React.Fragment, null, this.state.currentMailbox.authenticationMethod === 1 && /* @__PURE__ */ React.createElement("div", { className: "row mt-3" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" })), /* @__PURE__ */ React.createElement("div", null, !this.state.changingPassword && this.state.currentMailbox.mailboxId !== 0 && /* @__PURE__ */ React.createElement("div", { className: "col-4 mt-3" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleChangePassword,
          className: "btn btn-primary btn-sm mt-2"
        },
        "Change password"
      )), this.state.changingPassword && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "row mt-3" }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", null, "New Password:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          className: "form-control",
          value: this.state.newPass1,
          onChange: (e) => this.editNewPass(e, "newPass1")
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", null, "Confirm New Password:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          className: "form-control",
          value: this.state.newPass2,
          onChange: (e) => this.editNewPass(e, "newPass2")
        }
      ))), /* @__PURE__ */ React.createElement("div", null, !this.state.showPasswordErrors && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.UpdateChangePassword2,
          className: "btn btn-success mt-1"
        },
        "Update Password"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleChangePassword,
          className: "btn btn-secondary mt-1 ms-2"
        },
        "Cancel"
      ))), this.state.changingPassword && this.state.showPasswordErrors && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "alert alert-warning mt-3 ms-2 p-2",
          style: { maxWidth: "500px" }
        },
        /* @__PURE__ */ React.createElement("ul", null, this.state.passwordErrors.map((error) => /* @__PURE__ */ React.createElement("li", { key: error.key }, error.error)))
      ))), this.state.currentMailbox.authenticationMethod === 3 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch mt-3" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          checked: this.state.currentMailbox.useSystemClientId,
          onChange: this.toggleUseSystemClientId,
          type: "checkbox"
        }
      ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Use System Client Id")), !this.state.currentMailbox.useSystemClientId && /* @__PURE__ */ React.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Client Id"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          value: this.state.currentMailbox.clientId,
          onChange: this.editClientId,
          className: "form-control"
        }
      )), !this.state.isAuthenticating && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.startAuthentication,
          className: "mt-2 btn btn-primary"
        },
        "Authenticate"
      ), this.state.isAuthenticating && /* @__PURE__ */ React.createElement("button", { className: "mt-2 btn btn-primary" }, /* @__PURE__ */ React.createElement(
        "i",
        {
          className: "fa-solid fa-spinner fa-spin"
        }
      ), " ", "Authenticating...")))),
      this.state.currentMailbox.authenticationMethod === 4 && /* @__PURE__ */ React.createElement("div", { className: "card mt-2" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Credential settings")), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", null, "Credential:"), /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select",
          value: this.state.currentMailbox.credentialId,
          onChange: this.editCredential
        },
        /* @__PURE__ */ React.createElement("option", { value: "-1" }),
        this.state.currentAuthMethodCredentials.map((cred) => /* @__PURE__ */ React.createElement("option", { key: cred.id, value: cred.id }, cred.name))
      ))))),
      /* @__PURE__ */ React.createElement(
        Link,
        {
          id: "newMbLink",
          to: "/Admin/MailboxView/" + this.state.newMbId,
          style: { display: "none" }
        },
        "HiddenLink"
      )
    )), this.state.testResult !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { width: "400px", zIndex: 300 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Mailbox test result", " ", /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn-close",
          onClick: this.closeTestResult
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.testResult.result === "Success" && /* @__PURE__ */ React.createElement("div", { style: { color: "#3D9E31" } }, /* @__PURE__ */ React.createElement("h4", null, "Success")), this.state.testResult.result === "Error" && /* @__PURE__ */ React.createElement("div", { style: { color: "#9E3131" } }, /* @__PURE__ */ React.createElement("h4", null, "Error")), /* @__PURE__ */ React.createElement("div", null, this.state.testResult.message))
    )), this.state.oauthInstr !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { width: "600px", zIndex: 300 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "To authenticate your account:", " ", /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn-close",
          onClick: this.closeInstructions
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, this.state.oauthInstr.authMessage))
    )), this.state.authResult !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { width: "600px", zIndex: 300 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Authentication:", " ", /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn-close",
          onClick: this.closeInstructions
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.authResult.status === "Success" && /* @__PURE__ */ React.createElement("div", { style: { color: "#3D9E31" } }, /* @__PURE__ */ React.createElement("h4", null, "Success")), this.state.authResult.status === "Error" && /* @__PURE__ */ React.createElement("div", { style: { color: "#9E3131" } }, /* @__PURE__ */ React.createElement("h4", null, "Error")), /* @__PURE__ */ React.createElement("div", null, this.state.authResult.authMessage))
    )), this.state.showTestSend && /* @__PURE__ */ React.createElement(
      MailboxSendTest,
      {
        close: this.closeTestSend,
        mailboxId: this.state.currentMailbox.mailboxId
      }
    ));
  }
}
export default MailboxView;
